export class EntraRestoreReportEntityRequiredActionsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "code",
            "baseName": "code",
            "type": "EntraRestoreReportEntityRequiredActionsInnerCodeEnum",
            "format": ""
        },
        {
            "name": "severity",
            "baseName": "severity",
            "type": "EntraRestoreReportEntityRequiredActionsInnerSeverityEnum",
            "format": ""
        },
        {
            "name": "detail",
            "baseName": "detail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportEntityRequiredActionsInner.attributeTypeMap;
    }
    constructor() {
    }
}
export var EntraRestoreReportEntityRequiredActionsInnerCodeEnum;
(function (EntraRestoreReportEntityRequiredActionsInnerCodeEnum) {
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["UserReissueCredentials"] = "USER_REISSUE_CREDENTIALS";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["UserReregisterMfa"] = "USER_REREGISTER_MFA";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppRepointClients"] = "APP_REPOINT_CLIENTS";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppReplaceClientSecret"] = "APP_REPLACE_CLIENT_SECRET";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppReuploadCertificate"] = "APP_REUPLOAD_CERTIFICATE";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppUpdateFederatedWorkload"] = "APP_UPDATE_FEDERATED_WORKLOAD";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppRegenerateSamlSigningCertificate"] = "APP_REGENERATE_SAML_SIGNING_CERTIFICATE";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppGrantConsent"] = "APP_GRANT_CONSENT";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppUpdateReferences"] = "APP_UPDATE_REFERENCES";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppRecreateIdentity"] = "APP_RECREATE_IDENTITY";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppReviewIdentifierUri"] = "APP_REVIEW_IDENTIFIER_URI";
    EntraRestoreReportEntityRequiredActionsInnerCodeEnum["AppReviewExtensionUsage"] = "APP_REVIEW_EXTENSION_USAGE";
})(EntraRestoreReportEntityRequiredActionsInnerCodeEnum || (EntraRestoreReportEntityRequiredActionsInnerCodeEnum = {}));
export var EntraRestoreReportEntityRequiredActionsInnerSeverityEnum;
(function (EntraRestoreReportEntityRequiredActionsInnerSeverityEnum) {
    EntraRestoreReportEntityRequiredActionsInnerSeverityEnum["Required"] = "required";
})(EntraRestoreReportEntityRequiredActionsInnerSeverityEnum || (EntraRestoreReportEntityRequiredActionsInnerSeverityEnum = {}));
